import { call, put, select } from 'redux-saga/effects';
import { urls } from '../../../common/urls';
import { getHttp, getHttpwithtoken, postHttpwithtoken } from '../../../common/ApiCall';
import {
  getPlacesFailure,
  getPlacesLoading,
  getPlacesSuccess,
} from '../../ducks/PlacesSlice';

// Get Places Handler
export function* handlerGetCities(action: any): Generator<any, void, any> {
  try {
    yield put(getPlacesLoading());
    const response: any = yield call(getHttpwithtoken, `${urls.baseURL}${urls.getCities}`);
    
    if (response.success) {
      yield put(getPlacesSuccess(response.data));
    } else {
      yield put(getPlacesFailure(response.message || 'Failed to get places'));
    }
  } catch (error: any) {
    yield put(getPlacesFailure(error.message || 'Failed to get places'));
  }
}
